export interface IMergeLightWeightObjectsResult<T> {
    mergedResult: T[];
    disabledItemIds: number[];
}
export function mergeLightWeightObjects<T extends { Id: number }>(
    availableItems: T[] = [],
    existingItems: T[] = [],
): IMergeLightWeightObjectsResult<T> {
    const disabledItems = existingItems.filter((item) => {
        return !availableItems.find((availableItem) => availableItem.Id === item.Id);
    });

    const mergedResult = availableItems.concat(disabledItems);
    const disabledItemIds = disabledItems.map((item) => item.Id);

    return {
        mergedResult,
        disabledItemIds,
    };
}
